import { render, staticRenderFns } from "./DesignInformEV.vue?vue&type=template&id=166e7a5e&scoped=true"
import script from "./DesignInformEV.vue?vue&type=script&lang=js"
export * from "./DesignInformEV.vue?vue&type=script&lang=js"
import style0 from "./DesignInformEV.vue?vue&type=style&index=0&id=166e7a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166e7a5e",
  null
  
)

export default component.exports